<div class="content">
    <color-widget [formControl]="colorControl" trans>Canvas Background</color-widget>
</div>